import React from "react";

const ResetRedirect = () => {
  return (
    <div>
      <div className="successDiv">Password Reset Mail Sent Successfully!</div>
      <div className="toProceed">
        Please follow the link you have received in the inbox to set your new
        password
      </div>
    </div>
  );
};

export default ResetRedirect;
